// Ortak marka footer'ı.
export default function BrandFooter() {
  return (
    <div className="footer-dmenu">
      <a
        target="_blank"
        className="footer-link"
        href="https://noxussoft.com"
        rel="noreferrer"
      >
        Noxus Soft © 2026
      </a>
    </div>
  );
}
